import React from "react";
import {
  FormControl,
  InputLabel,
  ListItemText,
  MenuItem,
  OutlinedInput,
  Select,
} from "@mui/material";
import { compensationData } from "./getconstdata";

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

const Compensation = ({ getData, getOnSave }) => {
  const onSelect = (value) => {
    getOnSave("compensation", value);
  };

  return (
    <>
      <section className="compensationSection">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="heading">
                <h4>6. Current Compensation Range</h4>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-4 col-md-6">
              <FormControl sx={{ m: 1, width: 300 }} className="mainForm">
                <InputLabel id="compensation" className="salaryLabel">
                  Select Range
                </InputLabel>
                <Select
                  labelId="compensation"
                  id="compensation-checkbox"
                  value={getData}
                  onChange={(e) => onSelect(e.target.value)}
                  input={<OutlinedInput label="Select Range" />}
                  MenuProps={MenuProps}
                  className="rangeInput"
                >
                  {compensationData.map((name) => (
                    <MenuItem key={name} value={name}>
                      <ListItemText className="RangeLabel" primary={name} />
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Compensation;
